module.exports = __webpack_public_path__ + "static/SpinningHabitat4-ce595660e458fb69b9a318e68b7727c0.mp4";